import { loc } from './lib/_location.js';
import { common } from './_common.js';
import { createShopifyClient } from './dictionary/_shopifyItems.js';
import { createProductsClient } from './dictionary/_shopifyProducts.js';
import { productsData } from './dictionary/pjax/_collections.js';
import { indexGrid } from './lib/_index_grid.js';
import { pjax } from './dictionary/_page.js';

//debug
//import { makeLog } from './lib/_makelog.js';

export class Framework {
	constructor(){
		this.pageinfo = loc.all();
		this.nextpage = "";
		this.afterChangePage(); // async 関数を呼び出す
		console.log(this.pageinfo);
	}
	
	async afterChangePage(){
		common.init();
		common.resize();
		common.nav();
		const itemsClient = createShopifyClient({ shop: '0tgpcj-k6' });
		const productsClient = createProductsClient({ shop: '0tgpcj-k6' });
		
		const items = await itemsClient.fetchAllItems({ pageSize: 250 });
		const products = await productsClient.fetchAllProducts({ pageSize: 250 });
		productsData.all = products.sort((b, a) => 
			b.handle.localeCompare(a.handle, 'ja')
		);;
		
		const merged = [...items, ...products];
		//console.log(items, products);
		//console.log("merged:", merged);
		indexGrid.init(merged);
		//const items = await client.fetchAllItems({ pageSize: 50 });
		//console.log(items);
		this.framework = pjax;
		//console.log(this.framework)
		let $header = document.querySelector("header");
		let $footer = document.querySelector("footer");
		if( $header ){
			blockScroll(document.querySelector('header'));
		}
		if( $footer ){
			blockScroll(document.querySelector('footer'));
		}
		//makeLog.init();
	}
}
function blockScroll(el) {
	if (!el) return;
	// マウス/トラックパッド
	//el.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
	// タッチ（iOS含む）
	el.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
}


function mergeItemsAndProducts(items, products) {
	// products を handle → product にマップしておく
	const productMap = new Map(products.map(p => [p.handle, p]));
	
	return items.map(item => {
		const product = productMap.get(item.handle) || {};
		return {
			...item,         // 既存 item フィールド
			product: product // product をネストして入れる
		};
	});
}